import React from "react";
import ReactDOM from "react-dom/client";
import Widget from "./components/Widget";
import { ModalDialogContextProvider } from "./contexts/ModalDialogContext";
import { WidgetSettingsContextProvider } from "./contexts/WidgetSettingsContext";
import { GlobalStyle } from "./styles/global";

const loadFont = () => {
  const font = document.createElement("link");
  font.setAttribute("rel", "stylesheet");
  font.setAttribute("type", "text/css");
  font.setAttribute(
    "href",
    "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
  );
  document.head.appendChild(font);
};

export const bootWidget = () => {
  const div = document.createElement("div");
  div.setAttribute("id", "fuzey-widget-root");

  const body = document.body as HTMLElement;
  body.appendChild(div);

  const root = ReactDOM.createRoot(div);

  root.render(
    <React.StrictMode>
      <WidgetSettingsContextProvider>
        <ModalDialogContextProvider>
          <GlobalStyle />
          <Widget />
        </ModalDialogContextProvider>
      </WidgetSettingsContextProvider>
    </React.StrictMode>,
  );
};

export const startWidget = () => {
  loadFont();

  try {
    bootWidget();
  } catch (_error) {
    if (document.readyState === "complete") {
      setTimeout(() => {
        bootWidget();
      }, 2000);
    } else {
      window.addEventListener("load", bootWidget);
    }
  }
};
